module.exports = __webpack_public_path__ + "img/mc_p.4687f625.png";